type Props = {
    title?: string;
    message: string;
    variant?: "neutral" | "error";
};

export default function DataBankEmptyState({
    title = "No data available",
    message,
    variant = "neutral",
}: Props) {
    const textClass = variant === "error" ? "text-red-600" : "text-gray-600";
    return (
        <div className="flex min-h-[200px] flex-1 items-center justify-center p-6">
            <div className="max-w-md rounded-xl border border-gray-200 bg-white px-6 py-8 text-center shadow-sm">
                <p className={`text-sm font-semibold ${textClass}`}>{title}</p>
                <p className="mt-2 text-sm text-gray-500">{message}</p>
            </div>
        </div>
    );
}
